import styled from 'styled-components';
import Link from 'next/link';
import { Divider, Card } from 'antd';
import Image from 'components/Image';
import ActionButtons from './ActionButtons';
import { merriweather } from 'styles/GlobalStyle';

const IssueName = styled.h2`
    font-family: ${merriweather.style.fontFamily};
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    a {
        color: ${({ theme }) => theme.colors.brownishGrey};
    }
`;

const CardHeader = styled.span`
    font-size: 20px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    a {
        color: ${({ theme }) => theme.colors.brownishGrey};
    }
`;

const CardTopic = styled.h1`
    font-size: 22px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    a {
        color: ${({ theme }) => theme.colors.brownishGrey};
    }
`;

const DividerStyled = styled(Divider)`
    border-top: 2px solid #b7cbd9;
    margin-top: 5px;
    width: 80%;
`;

const CardStyled = styled(Card)`
    .ant-card-cover {
        border: 1px solid #b7cbd9;
    }
    .ant-card-body {
        padding: 0;
    }
`;

const CoverPhoto = styled.div`
    a > div > img {
        display: block !important;
        margin: 0 auto !important;
    }
`;

const CardToCText = styled.span`
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    a {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const ActionsWrapper = styled.div`
    margin-top: 1rem;
    margin-bottom: 2rem;
`;

export const Issue = ({ $issue }: { $issue: Issue }) => {
    return (
        <CardStyled
            bordered={false}
            cover={
                <CoverPhoto>
                    <Link href={`/wydanie/${$issue.seoSlug}`}>
                        <div>
                            <Image
                                alt={$issue.name || 'Okładka magazynu'}
                                type="issue"
                                width={190}
                                height={272}
                                src={$issue.cover}
                            />
                        </div>
                    </Link>
                </CoverPhoto>
            }
            style={{ boxShadow: 'none', padding: 0 }}
        >
            <IssueName>
                <Link href={`/wydanie/${$issue.seoSlug}`}>{`${$issue.number}/${$issue.year}`}</Link>
            </IssueName>
            {($issue.eIssueUrl || $issue.whitePaper) && (
                <ActionsWrapper>
                    <ActionButtons $issue={$issue} />
                </ActionsWrapper>
            )}
            <CardHeader>Temat z okładki:</CardHeader>
            <DividerStyled />
            <CardTopic>
                <Link href={`/wydanie/${$issue.seoSlug}`}>{$issue.topic}</Link>
            </CardTopic>
            <CardToCText>
                <Link href={`/wydanie/${$issue.seoSlug}#spis-tresci`}>Spis treści</Link>
            </CardToCText>
        </CardStyled>
    );
};

export default Issue;
